export default __webpack_public_path__ + "static/media/homePageImg.0be52136.jpg";